import e from "./ponyfillGlobal.mjs";
e.__MUI_LICENSE_INFO__ = e.__MUI_LICENSE_INFO__ || {
  key: void 0
};
class t {
  static getLicenseInfo() {
    return e.__MUI_LICENSE_INFO__;
  }
  static getLicenseKey() {
    return t.getLicenseInfo().key;
  }
  static setLicenseKey(_) {
    const n = t.getLicenseInfo();
    n.key = _;
  }
}
export {
  t as LicenseInfo
};
//# sourceMappingURL=licenseInfo.mjs.map
